module.exports = __webpack_public_path__ + "img/Slider_Feria_del_Trabajo_2021.d02787f3.png";